import { Swiper, Navigation, Pagination, Thumbs, Autoplay } from 'swiper'
import 'swiper/swiper-bundle.min.css'

Swiper.use([Navigation, Pagination, Thumbs, Autoplay])

let BetSwiper = new Swiper('.BetSwiper', {
  spaceBetween: 10,
  slidesPerView: 'auto',
  centeredSlides: false,
  slideToClickedSlide: true,
  noSwiping: false,
  breakpoints: {
    768: {
      spaceBetween: 17,
      noSwiping: false,
    },
    1200: {
      noSwipingClass: 'swiper-wrapper',
      noSwiping: true,
    }
  },
  pagination: {
    el: '.swiper-pagination',
  },
})

let galleryThumbs = new Swiper('.gallery-thumbs', {
  spaceBetween: 0,
  centeredSlides: true,
  slidesPerView: 'auto',
  slideToClickedSlide: true,
  thumbs: {
    swiper: galleryTop
  },
  autoplay: {
    delay: 5000,
    disableOnInteraction: false
  },
  breakpoints: {
    992: {
      spaceBetween: 2,
      centeredSlides: false
    }
  }
})

let galleryTop = new Swiper('.gallery-top', {
  spaceBetween: 0,
  thumbs: {
    swiper: galleryThumbs
  },
  autoplay: {
    delay: 5000,
    disableOnInteraction: false
  }
})

galleryThumbs
BetSwiper
galleryTop

galleryThumbs.on('slideChange', () => {
  galleryTop.slideToLoop(galleryThumbs.realIndex)
})
